import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_20401_90168)",
		children: [/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_20401_90168)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M70 115C94.8528 115 115 94.8528 115 70C115 45.1472 94.8528 25 70 25C45.1472 25 25 45.1472 25 70C25 94.8528 45.1472 115 70 115Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("path", {
			d: "M70.5 37C52.5499 37 38 51.5499 38 69.5001C38 87.4501 52.5499 102 70.5 102C88.4501 102 103 87.4501 103 69.5001C103 51.5499 88.4501 37 70.5 37ZM68.7092 97.7925C57.3185 97.5731 45.034 88.4713 42.6228 74.8817H61.6428V88.8363C59.7152 88.6656 54.3714 84.3341 53.1739 81.9426H57.8973V78.528C54.4594 78.528 51.0216 78.528 47.5855 78.528C47.9954 83.8916 58.6525 93.123 65.0232 93.5851V71.4024H42.1571V67.7056H65.0268V45.4779C58.4709 46.1018 48.7434 54.4898 47.5351 60.5439H57.9118V57.1599H53.0318C55.3387 53.9738 58.1221 51.7136 61.6014 50.0593V64.2066H42.5743C43.6981 58.5534 46.2046 53.7112 50.1981 49.6548C55.265 44.5051 61.4467 41.7577 68.7092 41.1589V97.7925ZM93.4559 78.5406H83.0918V81.9066H87.9701C85.6468 85.0911 82.8779 87.371 79.4058 88.9982V74.8601H98.3322C96.5756 86.4072 85.7872 97.2514 72.2658 97.8411V41.1733C78.6542 41.6336 84.2839 43.883 89.1118 48.0671C94.0492 52.3483 97.1042 57.7317 98.4329 64.2066H79.404V50.2068C81.5598 50.6347 86.3913 54.5688 87.8604 57.1329H83.0775V60.5564H93.4847C91.7369 53.9971 82.2125 45.8357 75.9589 45.4869V67.6786H98.8447V71.3663H75.9679V93.5977C82.5255 92.9755 92.0732 84.762 93.4559 78.5406Z",
			fill: "#ED3B3B"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_20401_90168",
		x: 0,
		y: 0,
		width: 140,
		height: 140,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_20401_90168"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_20401_90168",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_20401_90168",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 140,
			height: 140,
			fill: "white"
		})
	})] })]
});
export default SvgSendTransfer;
